import { Dispatch, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useMapEvents } from "react-leaflet";
import { Map } from "leaflet";
import debounce from "lodash/debounce";

import { setLeafletBbox } from "../../../../redux/mapBboxSlice";
import { setAreYearsPlaying } from "../../../../redux/yearsSlice";

const calcAndSetLeafletBbox = (dispatch: Dispatch<any>, map: Map) => {
  const mapBounds = map.getBounds();
  const leafletBbox = [mapBounds.getWest(), mapBounds.getSouth(), mapBounds.getEast(), mapBounds.getNorth()];
  dispatch(setLeafletBbox(leafletBbox));
};

export default function MapEvents(): null {
  const dispatch = useDispatch();
  const debounceWait = 100;

  const map = useMapEvents({
    moveend: debounce(() => {
      dispatch(setAreYearsPlaying(false));
      calcAndSetLeafletBbox(dispatch, map);
    }, debounceWait)
  });

  // Unset leafletBbox on unmount
  useEffect(() => {
    return () => {
      dispatch(setLeafletBbox(null));
    };
  }, [dispatch]);

  return null;
}
